import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Stars from '../common/Stars';

export default function Testimonials({ section }) {
  const d = section.data || {};
  const items = section.items || [];
  if (!items.length) return null;
  const id = `tm-${section.id}`;
  return (
    <section className="sf-testimonials relative testimonials-2" style={{ backgroundColor: d.background || '#f7f8fa', '--star-color': d.starColor || '#000000' }}>
      <div className="w-full section-my py-16" style={{ marginTop: 0, marginBottom: 0 }}>
        <div className="sf-testimonials__header relative text-center">
          <div className="section__header text-center px-5">
            {d.subheading && <p className="section__subheading">{d.subheading}</p>}
            <h2 className="section__heading">{d.heading || 'What People Are Saying'}</h2>
          </div>
        </div>
        <div className="sf-testimonials__container relative px-5 container-fluid">
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 6000, disableOnInteraction: false }}
            pagination={{ el: `.${id}-pag`, clickable: true }}
            spaceBetween={30}
            breakpoints={{ 0: { slidesPerView: 1 }, 768: { slidesPerView: 2 }, 1024: { slidesPerView: Number(d.columns) || 3 } }}
            className="swiper-container swiper-container-initialized"
          >
            {items.map((t, i) => (
              <SwiperSlide key={t._id || i}>
                <div className="review-block cursor-[grab] select-none px-[15px] md:px-0 h-full">
                  <div className="bg-white py-12 px-4 md:px-9 text-center rounded-[5px] h-full">
                    <div className="stars flex mb-[18px] justify-center"><Stars value={t.rating || 5} size={16} /></div>
                    {t.title && <h3 className="text-xl mb-2.5 font-medium not-change">{t.title}</h3>}
                    <div className="mb-6 text-color-subtext rte not-change"><p>“{t.text}”</p></div>
                    <div className="not-change font-medium"><p>{t.name}</p></div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className={`swiper-pagination w-full mt-6 ${id}-pag`} />
        </div>
      </div>
    </section>
  );
}
